import {createAction} from '@reduxjs/toolkit';

export const resize = createAction('RESIZE');

export const showModal = createAction('SHOW_MODAL');
export const hideModal = createAction('HIDE_MODAL');

export const setMode = createAction('SET_MODE');

export const showLeftDrawer = createAction('DRAWER_SHOW_LEFT');
export const showRightDrawer = createAction('DRAWER_SHOW_RIGHT');

export const setSaveErrors = createAction('SAVE_ERRORS');
